package ir.yusefpasha.style

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.hover
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.css.deg

val BackToTopStyle by ComponentStyle {

    base {
        Modifier.rotate(180.deg).transition(CSSTransition(property = "rotate", duration = Constants.ANIMATION_DURATION))
    }

    hover {
        Modifier.rotate(0.deg).transition(CSSTransition(property = "rotate", duration = Constants.ANIMATION_DURATION))
    }
}